// @flow
export const SAVE_KEY: string = 'SAVE_KEY';
export const SAVE_SELECT: string = 'SAVE_SELECT';
export const SET_INPUT: string = 'SET_INPUT';
export const SAVE_SUGGESTIONS: string = 'SAVE_SUGGESTIONS';
export const CLEAR_SUGGESTIONS: string = 'CLEAR_SUGGESTIONS';
export const SAVE_GIFS: string = 'SAVE_GIFS';
export const CLEAR_GIFS: string = 'CLEAR_GIFS';
export const SET_CHOSEN: string = 'SET_CHOSEN';
